import { supabase } from '../lib/supabase';

// Alternative password reset that works around network issues
export const alternativePasswordReset = async (email) => {
  try {
    console.log('Attempting alternative password reset for:', email);
    
    // Use the working endpoint but with different redirect URLs
    const redirectUrls = [
      `${window.location.origin}/reset-password`,
      `http://localhost:3000/reset-password`,
      `http://127.0.0.1:3000/reset-password`,
      `${window.location.protocol}//${window.location.host}/reset-password`
    ];
    
    let lastError = null;
    
    for (const redirectUrl of redirectUrls) {
      try {
        console.log(`Trying redirect URL: ${redirectUrl}`);
        
        const { data, error } = await supabase.auth.resetPasswordForEmail(email, {
          redirectTo: redirectUrl
        });
        
        if (!error) {
          console.log('Success with redirect URL:', redirectUrl);
          return { 
            success: true, 
            redirectUrl,
            message: 'Password reset email sent successfully!' 
          };
        } else {
          lastError = error;
          console.log('Failed with redirect URL:', redirectUrl, error);
        }
      } catch (err) {
        lastError = err;
        console.log('Exception with redirect URL:', redirectUrl, err);
        continue;
      }
    }
    
    // If all redirect URLs failed, return the last error
    return {
      success: false,
      error: lastError,
      message: 'Failed to send password reset email'
    };
    
  } catch (error) {
    console.error('Alternative password reset failed:', error);
    return {
      success: false,
      error,
      message: 'Failed to send password reset email'
    };
  }
};

// Test function specifically for localhost variants
export const testLocalhostVariants = async (email) => {
  const variants = [
    'localhost:3000',
    '127.0.0.1:3000',
    'localhost:3001',
    '127.0.0.1:3001'
  ];
  
  const results = [];
  
  for (const host of variants) {
    const redirectUrl = `http://${host}/reset-password`;
    
    try {
      const { data, error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: redirectUrl
      });
      
      results.push({
        host,
        redirectUrl,
        success: !error,
        error: error?.message
      });
      
      // Small delay between requests
      await new Promise(resolve => setTimeout(resolve, 500));
      
    } catch (err) {
      results.push({
        host,
        redirectUrl,
        success: false,
        error: err.message
      });
    }
  }
  
  return results;
};
